import * as actionTypes from "../constants/actionTypes";
import * as handlers from "../constants/handlers";
import * as methods from "../constants/methods";

export const getPartialUpdatesCount = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_PREPARED_PARTIAL_UPDATES_COUNT
    },
    method: handlers.GET_PREPARED_PARTIAL_UPDATES_COUNT,
    tabId: 0
});

export const getNewPartialUpdates = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_ALL_PREPARED_UPDATES_PER_DATABASE
    },
    method: handlers.GET_ALL_PREPARED_UPDATES_PER_DATABASE,
    tabId: 0
});

export const applyAllPartialUpdates = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_APPLY_ALL_PREPARED_UPDATES_PER_DATABASE
    },
    method: handlers.APPLY_ALL_PREPARED_UPDATES_PER_DATABASE,
    tabId: 0
});

export const setPartialUpdatesPreparing = (value, databaseId) => ({
    type: actionTypes.SET_PARTIAL_UPDATES_PREPARING,
    payload: {
        value: value,
        databaseId: databaseId
    }
});
